module.exports = __webpack_public_path__ + "static/img/head-photo.72c37eea.png";